import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { SnackbarProvider } from 'notistack'
import { BrowserRouter as Router } from "react-router-dom"
import App from './App'
import * as serviceWorker from './serviceWorker'

import store from './store'

// import Params from './components/modals/params'

import 'antd/dist/antd.css'

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <SnackbarProvider>
                <Router>
                    <App />
                </Router>
            </SnackbarProvider>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
)

serviceWorker.unregister()
